import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useDeleteBillingPlan(): UseMutationResult<
  AxiosResponse<null>,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  const deleteBillingPlan = (billingPlanId: string): Promise<AxiosResponse<null>> => {
    return client.delete(`billing-plans/${billingPlanId}/`);
  };

  return useMutation(deleteBillingPlan, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['packages'],
      });
      queryClient.removeQueries({
        queryKey: ['billingPlans'],
      });
    },
  });
}
